import React, { Component } from 'react';
import { withRouter, Link } from "react-router-dom";
import { FormControl, FormGroup, Row, Col, Alert, Modal, Button} from 'react-bootstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/fontawesome-free-solid';
import { msgs } from 'src/js/ErrorMessage.js';
import 'src/css/LoginForm.css'
import 'src/i18n';
import { withTranslation, Trans } from 'react-i18next';

class ForgotPassForm extends Component {

  constructor() {
    super();    
    // 画面最上部まで移動
    window.scrollTo(0,0);

    this.onClick = this.onClick.bind(this);
  }

  handleModal(){
    window.location.href= "/forgotpass-verification"
  }

  onClick() {
    console.log(this.inputId.value);
    this.props.resetPass(this.inputId.value);
  }

  render() {
    const Error = () => (
      <div>
        {
          this.props.resetIsFail ? <Alert bsStyle="danger">
          <p>
              <Trans i18nKey={"Message." + msgs[this.props.resetIsFailMsgIndex]}>
                {msgs[this.props.resetIsFailMsgIndex]}
              </Trans>
            </p>
            </Alert> : false
        }
      </div>
    );

    const ResetButton = () => (
      <button type="submit" id="circleButton" className="loginButton" disabled={this.props.resetPassLoading} onClick={this.onClick}>
        {
          this.props.resetPassLoading ? <FontAwesomeIcon size='1x' icon={faSpinner} spin /> : <Trans i18nKey="ForgotPassword.Reset">Reset</Trans>
        }
      </button>
    );

    return (
      <div>
        {this.props.verificationCodeSucceed && (
          <Modal show={true} onHide={this.handleHideModal} dialogClassName="check-modal">
            <Modal.Body>
              <Trans i18nKey="Message.ResetSucceed">
              VerificationCode has been sent to your email address.<br/>
              If you have closed this page by mistake, please request to send it again.
              </Trans>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.handleModal}>OK</Button>
            </Modal.Footer>
          </Modal>
        )}
        <Link to="/login">
          &lt;&lt; <Trans i18nKey="SignUp.Back">Back to login page</Trans>
        </Link>
        <Row>
          <Col xs={10} xsOffset={1}>
            <Error />
          </Col>
        </Row>
        {/* ID入力フォーム */}
        <FormGroup controlId="formHorizontalId" >
          <Row>
            <Col xsOffset={1} xs={10}>
              <p className="formText"><Trans i18nKey="Common.ID">VIN No.</Trans></p>
            </Col>
          </Row>
          <Row>
            <Col xsOffset={1} xs={10}>
              <FormControl className="form" type="text"  bsSize="large" componentClass="input" inputRef={(ref) => { this.inputId = ref }} />
            </Col>
          </Row>
        </FormGroup>
        {/* 確認コード送信ボタン */}
        <div className='short-div' />
          <Row id="button-forms">
            <div className="explanation">
              <Trans i18nKey="ForgotPassword.GuideMsg">
                Click the "Reset" button to send an email to the registered contacts.<br/>
                If you do not receive the email, the VinNo may be wrong or does not exist.
              </Trans>
            </div>
            <FormGroup>
              <ResetButton />
              <Col className="HeartLogo" md={4} sm={4} xs={10} mdOffset={4} smOffset={4} xsOffset={1}></Col>
            </FormGroup>
          </Row>
          
      </div>
    );
  }
}

export default withTranslation()(withRouter(ForgotPassForm));



// WEBPACK FOOTER //
// ./src/component/ForgotPass/ForgotPassForm.js